import type { XYChartRectSeriesProps } from '../types/xy-chart-props.js';

export const RectSeries = (props: XYChartRectSeriesProps) => null;

RectSeries['displayName'] = 'XYChart.RectSeries';
